module.exports = __webpack_public_path__ + "static/36-979aa19318d28fc3c2cc2faad9eaedd8.gif";